import React from 'react';
import { AutoInteractionState, } from '../../store/autoInteraction/AutoInteractionState';
import { useI18n } from '../../locale/I18nContext';
import { Tokenizer } from '@sas/nova-commons/components/Tokenizer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectAutoInteractionState } from '../../store/selectors';
import { exposeTestId } from '../../config';
import { useDesignTokens } from '@sas/nova-commons/theme';
import cn from './AutoInteractionBar.css.json';
import './AutoInteractionBar.css';
export const AutoInteractionBarBase = ({ id, actions, state }) => {
    const localize = useI18n();
    const groupLabels = {};
    const tokens = [];
    const tokenLocations = new Map();
    state === null || state === void 0 ? void 0 : state.items.forEach(({ values, readonly, label }, itemIndex) => {
        const groupId = '' + itemIndex;
        groupLabels[groupId] = `${label}`;
        values.forEach((value, valueIndex) => {
            const token = { groupId, value, readOnly: readonly };
            tokens.push(token);
            tokenLocations.set(token, valueIndex);
        });
    });
    const onCloseToken = (token) => {
        const valueIndex = tokenLocations.get(token);
        if (valueIndex === undefined) {
            console.warn('Attempted to remove an unknown token');
        }
        else {
            actions.deleteValue(id, {
                itemIndex: Number(token.groupId),
                valueIndex,
            });
        }
    };
    const onCloseGroup = (groupId) => {
        const itemIndex = Number(groupId);
        actions.deleteItem(id, { itemIndex });
    };
    const dt = useDesignTokens();
    if (!state || !state.showControl) {
        return null;
    }
    else {
        return (React.createElement("div", { style: { '--auto-interaction-bar-fg': dt.c.n_1 }, className: cn.bar, "data-testid": exposeTestId() ? 'autoInteractionBar' : undefined },
            React.createElement("div", { className: cn.label },
                React.createElement("span", null, localize({ key: 'SectionSelectionBar.title.txt' }))),
            state.items.length ? (React.createElement(Tokenizer, { className: cn.tokenizer, tokens: tokens, groupLabelMap: groupLabels, hasBreadcrumbs: state.mode === 'onewayfilter', onCloseGroup: onCloseGroup, onCloseToken: onCloseToken, onRemoveTokens: () => { }, groupEnabled: true, groupingThreshold: 2 })) : (React.createElement("label", { className: cn.placeholder },
                React.createElement("span", null, localize({ key: 'SectionSelectionBar.noSelections.txt' }))))));
    }
};
export const AutoInteractionBar = connect((state, props) => ({
    state: selectAutoInteractionState(state, props.id),
}), (dispatch) => ({ actions: bindActionCreators(AutoInteractionState.actions, dispatch) }))(AutoInteractionBarBase);
